import { createUseStyles } from 'react-jss'
import { boldFont, titleFontSemiBold, textSize, backgroundColor, color } from 'styles/helpers'
import config from 'styles/config'

const { boxMobileMargin, boxMargin } = config.dimensions

const sharedStyles = createUseStyles(theme => ({
  title: {
    display: 'block',
    position: 'relative',
    padding: `${boxMobileMargin}px 0`,
    marginBottom: boxMobileMargin,
    ...titleFontSemiBold(),
    ...textSize(16, 19),
    borderBottom: `1px solid ${config.colors.boxSeparator}`
  },

  subTitle: {
    ...textSize(14, 19),
    opacity: 0.6
  },

  titleIcon: {
    position: 'absolute',
    right: boxMobileMargin,
    color: theme.main_color,
    fontSize: 20,
  },

  tableAttribute: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 13,
    paddingBottom: 14,
    borderBottom: `1px solid ${config.colors.boxSeparator}`,
    ...textSize(14, 16),
    '&:last-child': {
      borderBottom: 'none'
    }
  },

  tableAttributeContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '&:last-child': {
      paddingRight: 40
    }
  },

  tableAttributeLabel: {
    display: 'block',
    marginBottom: 4,
    paddingRight: 48,
    ...boldFont(),
  },

  tableAttributeEdit: {
    padding: '4px 3px 4px 21px', // 40x40 square
    fontSize: 16,
    ...color('boxIcon')
  },

  contentBox: {
    position: 'relative',
    marginBottom: 16,
    padding: boxMobileMargin,
    ...backgroundColor('mainBackground'),
    borderTop: `1px solid ${config.colors.divider}`,
    borderBottom: `1px solid ${config.colors.divider}`,
    borderRadius: 2,
    overflow: 'hidden',

    '& $title': {
      marginLeft: -boxMobileMargin,
      marginRight: -boxMobileMargin,
      marginTop: -boxMobileMargin,
      textIndent: boxMobileMargin
    },

    '& $tableAttribute': {
      marginLeft: -boxMobileMargin,
      marginRight: -boxMobileMargin,
      paddingLeft: boxMobileMargin,
      paddingRight: boxMobileMargin,
      '&:first-child': {
        marginTop: -boxMobileMargin
      },
      '&:last-child': {
        marginBottom: -boxMobileMargin
      },
    }
  },

  [config.mediaQueries.tabletPortrait]: {
    titleIcon: {
      fontSize: 22,
      right: boxMargin,
    },

    contentBox: {
      padding: `${boxMobileMargin}px ${boxMargin}px`,
      border: `1px solid ${config.colors.divider}`,
      borderRadius: 6,

      '& $title': {
        marginLeft: -boxMargin,
        marginRight: -boxMargin,
        marginTop: -boxMobileMargin,
        textIndent: boxMargin
      },

      '& $tableAttribute': {
        marginLeft: -boxMargin,
        marginRight: -boxMargin,
        paddingLeft: boxMargin,
        paddingRight: boxMargin,
        '&:first-child': {
          marginTop: -boxMobileMargin
        },
        '&:last-child': {
          marginBottom: -boxMobileMargin
        },
      }
    },

    tableAttribute: {
      display: 'flex',
      paddingTop: 9,
      paddingBottom: 6,
      ...textSize(14, 30)
    },

    tableAttributeContent: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
  }
}))

export default sharedStyles
